<template>
  <div id="notFound">
    <img src="/static/img/ecalculo_name.png" class="center-block logo">

    <div class="text-center col-sm-12">
      <!-- <h1 class="">Please consult with our support Team.</h1> -->
      <h1>Are you Lost?</h1>
      <router-link to="/login" class="vertical-5p lead"><h1>Go Back</h1></router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
#notFound {
  padding: 10em;
  color: white;
}
.logo{
  height: 100px;
  float: center;
  float: left;
  margin-left: 50%;
}
h1{
  color: #4a7eec;
  margin-left: 10%;
}
</style>



// WEBPACK FOOTER //
// 404.vue?7673f46a